import React from 'react'
import Header from "../component/Header";
import SideBar from "../component/SideBar";
import { Outlet } from 'react-router-dom'

export default function Layout() {
    return (
        <>
            <main className="main" id="top">
                <div className="container-fluid">
                    <SideBar />
                    <div className="content">
                        <Header />
                        <Outlet />
                    </div>
                </div>
            </main>
        </>
    )
}
